import { IconInterface } from '../../interfaces/icon.interface';

export const AdminContracts = (props: IconInterface) => {
	const {
		isActive,
		color = '#1C274C',
		strokeWidth = '1',
		hoverEffect = false,
		width = 22,
		height = 22,
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
		>
			<path
				d="M19.5206 11.6473L20.0382 9.71542C20.6425 7.46034 20.9446 6.3328 20.7171 5.35703C20.5374 4.58657 20.1334 3.88668 19.556 3.34587C18.8247 2.66095 17.6971 2.35883 15.442 1.75458C13.187 1.15033 12.0594 0.848209 11.0836 1.07573C10.3132 1.25537 9.6133 1.65945 9.0725 2.23687C8.48608 2.86298 8.18027 3.77957 7.72519 5.44561C7.64877 5.7254 7.56814 6.02633 7.48126 6.35057L7.4812 6.35077L6.96356 8.28263C6.35932 10.5377 6.05719 11.6652 6.28471 12.641C6.46436 13.4115 6.86844 14.1114 7.44585 14.6522C8.17714 15.3371 9.30467 15.6392 11.5598 16.2435L11.5598 16.2435C13.5924 16.7881 14.7089 17.0873 15.624 16.9744C15.7241 16.9621 15.8219 16.9448 15.9182 16.9223C16.6886 16.7427 17.3885 16.3386 17.9293 15.7612C18.6142 15.0299 18.9164 13.9024 19.5206 11.6473Z"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M15.624 16.9741C15.4155 17.6126 15.0489 18.1902 14.556 18.6519C13.8247 19.3368 12.6971 19.6389 10.442 20.2432C8.18696 20.8474 7.05942 21.1495 6.08365 20.922C5.31319 20.7424 4.6133 20.3383 4.0725 19.7609C3.38757 19.0296 3.08545 17.9021 2.4812 15.647L1.96356 13.7151C1.35932 11.46 1.05719 10.3325 1.28471 9.35673C1.46436 8.58627 1.86844 7.88638 2.44585 7.34557C3.17714 6.66065 4.30468 6.35853 6.55976 5.75428C6.98639 5.63996 7.37267 5.53646 7.72519 5.44531"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M10.9863 9L15.816 10.2941"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M10.209 11.8984L13.1068 12.6749"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
		</svg>
	);
};
